"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxDisabledQuickBuyClicked = exports.Name = void 0;
const Name = exports.Name = 'product-box-disabled-quickbuy-clicked';
const ProductBoxDisabledQuickBuyClicked = exports.ProductBoxDisabledQuickBuyClicked = Name;
//# sourceMappingURL=index.js.map